import Utils from '@/ecm/common/Utils'
export default class StateTransitionAction {
    constructor (dto) {
        this.uuid = Utils.object.getUUID()
        this.defFieldCode = ''
        this.value = ''
        this.isParameterizable = false

        if (dto) {
            this.value = dto.Value
            this.defFieldCode = dto.DefFieldCode
            this.isParameterizable = dto.IsParameterizable
        }
    }

    toDto () {
        return {
            Value: this.value,
            DefFieldCode: this.defFieldCode,
            IsParameterizable: this.isParameterizable,
        }
    }
}
